// STEP 1 - Include Dependencies
// Include react
import React from "react";

// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

// STEP 2 - Chart Data
function InvestedValueCat3(props) {
  //console.log("INVCAT3--", props);
  let colors = ["#89C4F4", "#333333", "#808080", "#CCCCCC", "#BBBBBB"];
  let rows = [];
  Object.keys(props.doughnutInvested3).map((key, index) => {
    rows.push({
      key: key,
      label: props.doughnutInvested3[key].schemeName,
      value: props.doughnutInvested3[key].investedValue,
      // schemeName: props.doughnutInvested3[key].schemeName,
      color: colors[index],
      displayValue: props.doughnutInvested3[key].schemeDesc,
    });
  });

  const chartData = rows;
  // STEP 3 - Creating the JSON object to store the chart configurations
  const chartConfigs = {
    type: "doughnut2d", // The chart type
    width: "270", // Width of the chart
    height: "350", // Height of the chart
    dataFormat: "json", // Data type

    dataSource: {
      // Chart Configuration
      chart: {
        doughnutRadius: "65%",
        caption: "Invested Value",
        //subcaption: "For all users in 2017",
        showlabels: "0",
        showValues: "0",
        defaultcenterlabel: "₹" + props.totalInvested3,
        enableSlicing: "0",
        enableRotation: "0",
        captionpadding: "0",
        decimals: "1",
        plottooltext: "<b>$percentValue</b> {BR} <b>$displayValue</b>",
        // centerlabel: "# Invested Value: $value",
        theme: "fusion",
        // legendNumRows: "2",
        legendNumColumns: "2",
        legendItemFontSize: "12",
        chartLeftMargin: "0",
        chartTopMargin: "0",
        chartRightMargin: "0",
        chartBottomMargin: "0",
      },
      // Chart Data
      data: chartData,
    },
  };

  return <ReactFC {...chartConfigs} />;
}

export default InvestedValueCat3;
